"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyShort = void 0;
class CompanyShort {
    static from(userContext) {
        const c = new CompanyShort();
        if (userContext.companyId != null) {
            c.companyId = userContext.companyId;
            c.companyName = userContext.companyName;
        }
        c.userId = userContext.userId;
        return c;
    }
    static fromMetaData(metaData) {
        const c = new CompanyShort();
        c.companyId = metaData.ownerCompanyId;
        c.companyName = metaData.ownerCompanyName;
        c.userId = metaData.ownerUserId;
        return c;
    }
}
exports.CompanyShort = CompanyShort;
